import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Grand%20modern%20sports%20stadium%20filled%20with%20passionate%20fans%20dramatic%20night%20atmosphere%20with%20golden%20warm%20lighting%20and%20fireworks%20spectacular%20sports%20event%20scene%20epic%20scale%20professional%20photography%20atmospheric&width=1920&height=1080&seq=hero-sports-stadium&orientation=landscape"
          alt="开云爱体育 - 专业体育竞技平台"
          title="开云爱体育官方体育竞技平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs md:text-sm text-white/90 font-medium">2026赛季火热进行中</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            汇聚全球顶级赛事
            <br />
            <span className="text-accent-400">畅享极致竞技乐趣</span>
          </h1>

          <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            开云爱体育是专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供多元化体育项目体验。加入开云爱体育，享受极致竞技乐趣，畅享安全便捷的体育娱乐服务。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-foreground-950 font-semibold text-sm rounded-full hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
            >
              立即注册，开启体育之旅
            </Link>
            <Link
              to="/category/football"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-medium text-sm rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              浏览赛事
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[
              { number: '200+', label: '全球赛事', icon: 'ri-trophy-line' },
              { number: '50万+', label: '活跃用户', icon: 'ri-user-star-line' },
              { number: '24/7', label: '全天候服务', icon: 'ri-time-line' },
              { number: '100%', label: '安全可靠', icon: 'ri-shield-check-line' },
            ].map((stat, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-accent-400 text-xl`}></i>
                </div>
                <p className="text-xl md:text-2xl font-bold text-white">{stat.number}</p>
                <p className="text-xs text-white/60 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1">
          <div className="w-1 h-3 rounded-full bg-white/70 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}